module.exports = __webpack_public_path__ + "static/media/usps.179861a3.svg";